class Observer {
  constructor() {
    this.observers = {}
  }
  on(name, callback) {
    if (!(name in this.observers)) {
      this.observers[name] = []
    }
    this.observers[name].push(callback)
  }
  emit(name, ...args) {
    if (name in this.observers) {
      this.observers[name].forEach(callback => callback(...args))
    }
  }
}

export default Observer
